import Temp from "@/courier/Temp";

export default class ThailandPostFruit extends Temp {
  static CODE = "EMSF";

  constructor() {
    super(ThailandPostFruit.CODE);
  }

  async getZone(item) {
    let type;
    let cross_price = 0;
    let remote_area = 0;
    let fuel_surcharge = 0;

    type = super.checkZone(item.toPostcode);

    let fuel_surcharge_data = await super.getFuelSurcharge()

    if (fuel_surcharge_data) {
      fuel_surcharge = fuel_surcharge_data['*'] || 0
    }

    return {
      rate_type: type,
      rate_remote_area: remote_area,
      cross_price: cross_price,
      fuel_surcharge
    };
  }

  checkWeight(courierRates, item, validate) {
    item.index = courierRates.findIndex((rate) => {
      return item.weight >= rate.min && item.weight <= rate.max;
    });

    return super.checkRules(item, validate);
  }

  async checkRemoteAreaByCorrectorDest(addressRemote, option) {
    return new Promise((resolve) => {
      super.getArea([addressRemote], ["EMSF"], option).then((res) => {
        let weight = option.weight;
        let returnRate = {
          isRemote: 0,
          isTravelArea: 0,
          isIsland: res.data.EMSF.is_island ? 20 : 0
        };
        resolve(returnRate);
      });
    });
  }
}
